import styled from 'styled-components'

const StyledCreateBarContent = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr);
`

export default StyledCreateBarContent
